import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { configApi } from '../services/api'

export default function Home() {
  const navigate = useNavigate()
  const [thirdPartyEnabled, setThirdPartyEnabled] = useState(false)

  useEffect(() => {
    configApi.getPublic()
      .then((cfg) => setThirdPartyEnabled(cfg.thirdPartyShipping))
      .catch(() => setThirdPartyEnabled(false))
  }, [])

  return (
    <div className="min-h-screen page-enter" style={{ backgroundColor: '#eeeeee' }}>
      {/* Brand Header */}
      <div style={{ padding: '80px 24px 48px', textAlign: 'center' }}>
        <h1
          style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 36,
            fontWeight: 700,
            color: '#313131',
            letterSpacing: '0.15em',
          }}
        >
          浅形
        </h1>
        <p
          style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 14,
            color: '#9a9a9a',
            marginTop: 12,
            letterSpacing: '0.15em',
          }}
        >
          专业面板定制服务
        </p>
      </div>

      {/* Divider */}
      <div style={{ margin: '0 24px', height: 1, backgroundColor: '#dddddd' }} />

      {/* Main Entries */}
      <div style={{ padding: '40px 24px' }}>
        <p
          style={{
            fontSize: 11,
            color: '#9a9a9a',
            textAlign: 'center',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: 24,
          }}
        >
          选择您的身份
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* 我是下单方 */}
          <button
            onClick={() => navigate('/customer/query')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 20,
              padding: '28px 24px',
              backgroundColor: '#ffffff',
              border: '1px solid #dddddd',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                border: '1px solid #dddddd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#313131" strokeWidth="1.2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <h2
                style={{
                  fontFamily: '"Noto Sans SC", sans-serif',
                  fontSize: 17,
                  fontWeight: 500,
                  color: '#313131',
                  letterSpacing: '0.15em',
                }}
              >
                我是下单方
              </h2>
              <p style={{ fontSize: 13, color: '#9a9a9a', marginTop: 4, letterSpacing: '0.15em' }}>
                查询订单进度 · 管理地址 · 查看历史订单
              </p>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a9a9a" strokeWidth="1.2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* 我是材料寄件人 */}
          {thirdPartyEnabled && (
          <button
            onClick={() => navigate('/sender')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 20,
              padding: '28px 24px',
              backgroundColor: '#ffffff',
              border: '1px solid #dddddd',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                border: '1px solid #dddddd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#313131" strokeWidth="1.2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <h2
                style={{
                  fontFamily: '"Noto Sans SC", sans-serif',
                  fontSize: 17,
                  fontWeight: 500,
                  color: '#313131',
                  letterSpacing: '0.15em',
                }}
              >
                我是材料寄件人
              </h2>
              <p style={{ fontSize: 13, color: '#9a9a9a', marginTop: 4, letterSpacing: '0.15em' }}>
                为客户寄送定制材料 · 提交快递信息
              </p>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a9a9a" strokeWidth="1.2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
          )}
        </div>
      </div>
    </div>
  )
}
